import { createInstance } from '@app/services/api/createInstance'

import type { AttachmentOpenOptions } from './types'

const attachmentApi = createInstance({ requireAuth: true })

const loadAttachmentBlob = async (
  url: string,
  signal?: AbortSignal
): Promise<Blob> => {
  const response = await attachmentApi.get<Blob>(url, {
    responseType: 'blob',
    signal,
    headers: {
      Accept: '*/*',
    },
  })

  return response.data
}

export const downloadAttachmentAsObjectUrl = async (
  url: string,
  signal?: AbortSignal
): Promise<string> => {
  const blob = await loadAttachmentBlob(url, signal)
  return URL.createObjectURL(blob)
}

export const openAttachmentWithAuth = async (
  url: string,
  options: AttachmentOpenOptions = {}
): Promise<void> => {
  const { downloadName, target = '_blank', revokeDelayMs = 60_000 } = options

  const blob = await loadAttachmentBlob(url)
  const objectUrl = URL.createObjectURL(blob)

  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.target = target
  anchor.rel = 'noopener noreferrer'

  if (downloadName) {
    anchor.download = downloadName
  }

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)

  setTimeout(() => {
    URL.revokeObjectURL(objectUrl)
  }, revokeDelayMs)
}
